import { liteClient as algoliasearch } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';

// import getRouting from './routing';
import {
  artists,
  clearFilters,
  clearFiltersEmptyResults,
  clearFiltersMobile,
  configuration,
  dates,
  hitsPerPage,
  owners,
  pagination,
  products,
  provenances,
  resultsNumberMobile,
  saveFiltersMobile,
  searchBox,
  techniques,
  types,
} from './widgets';


const searchClient = algoliasearch(
  'QFUNBU0BK9',
  '7ea3ccbba8c38776262aa0dcda35df37'
);

const search = instantsearch({
  searchClient,
  indexName: 't_ex_libris',
  // routing: getRouting({ indexName: 'instant_search' }),
  insights: true,
});

search.addWidgets([
  artists,
  clearFilters,
  clearFiltersEmptyResults,
  clearFiltersMobile,
  configuration,
  dates,
  hitsPerPage,
  owners,
  pagination,
  products,
  provenances,
  resultsNumberMobile,
  saveFiltersMobile,
  searchBox,
  techniques,
  types,
]);

export default search;
